import { registerReactComponent } from '@trp-beacon-ui-kit/foundation/react/register';
import { BeaconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-button';
import { BeaconIconButton } from '@trp-beacon-ui-kit/foundation/components/beacon-icon-button';
import { BeaconModal } from '@trp-beacon-ui-kit/foundation/components/beacon-modal';
import { BeaconError } from '@trp-beacon-ui-kit/foundation/components/beacon-error';
import { BeaconTableHeader } from '@trp-beacon-ui-kit/foundation/components/beacon-table-header';
import { BeaconTableRecord } from '@trp-beacon-ui-kit/foundation/components/beacon-table-record';
import { BeaconTableStub } from '@trp-beacon-ui-kit/foundation/components/beacon-table-stub';
import { BeaconTable } from '@trp-beacon-ui-kit/foundation/components/beacon-table';
import { BeaconTooltip } from '@trp-beacon-ui-kit/foundation/components/beacon-tooltip';
import { BeaconFooter } from '@trp-beacon-ui-kit/foundation/components/beacon-footer';
import { BeaconSocialLink } from '@trp-beacon-ui-kit/foundation/components/beacon-social-link';
import { BeaconSocialLinkContainer } from '@trp-beacon-ui-kit/foundation/components/beacon-social-link-container';
import { BeaconNavigationFooter } from '@trp-beacon-ui-kit/foundation/components/beacon-navigation-footer';

// Prefix value to remove conflict with other component
const projectNamePrefix = `pamui`;

// Registered Beacon Components

export const PAMBeaconFooter = registerReactComponent(
  projectNamePrefix,
  BeaconFooter
);

export const PAMBeaconSocialLink = registerReactComponent(
  projectNamePrefix,
  BeaconSocialLink
);

export const PAMBeaconSocialLinkContainer = registerReactComponent(
  projectNamePrefix,
  BeaconSocialLinkContainer
);

export const PAMBeaconNavigationfooter = registerReactComponent(
  projectNamePrefix,
  BeaconNavigationFooter
);

export const PAMBeaconButton = registerReactComponent(
  projectNamePrefix,
  BeaconButton
);

export const PAMBeaconIconButton = registerReactComponent(
  projectNamePrefix,
  BeaconIconButton
);

export const PAMBeaconModal = registerReactComponent(
  projectNamePrefix,
  BeaconModal
);

export const PAMBeaconError = registerReactComponent(
  projectNamePrefix,
  BeaconError
);

export const PAMBeaconTableHeader = registerReactComponent(
  projectNamePrefix,
  BeaconTableHeader
);

export const PAMBeaconTableRecord = registerReactComponent(
  projectNamePrefix,
  BeaconTableRecord
);

export const PAMBeaconTableStub = registerReactComponent(
  projectNamePrefix,
  BeaconTableStub
);

export const PAMBeaconTable = registerReactComponent(
  projectNamePrefix,
  BeaconTable
);

export const PAMBeaconTooltip = registerReactComponent(
  projectNamePrefix,
  BeaconTooltip
);
